<script>
import ListaPrenotazioni from "@/components/ListaPrenotazioni.vue";
import ListaInterazioni from "@/components/ListaInterazioni.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import GestioneMaterie from "@/components/GestioneMaterie.vue";
import UserProfile from "@/components/UserProfile.vue";
import GestioneGruppi from "@/components/GestioneGruppi.vue";
import LastMinuteLessons from "@/components/LastMinuteLessons.vue";

export default {
  name: 'StudentDashboard',
  components: {
    LastMinuteLessons,
    GestioneGruppi,
    UserProfile,
    GestioneMaterie,
    NavigationTabs,
    ListaPrenotazioni,
    ListaInterazioni,
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    activeTab: {
      type: [String, Array],
      required: true
    }
  },
  data() {
    return {
      activeTabId: Array.isArray(this.activeTab) ? this.activeTab[0] : this.activeTab
    }
  },
  computed: {
    navigationTabs() {
      const allTabs = [
        {
          id: 'sezione-prenotazioni',
          label: 'Prenotazioni',
          event: 'show-prenotazioni'
        },
        {
          id: 'sezione-interazioni',
          label: 'Interazioni',
          event: 'show-interazioni'
        },
        {
          id: 'sezione-materie',
          label: 'Le mie conoscenze',
          event: 'show-materie'
        },
        {
          id: 'sezione-profilo',
          label: 'Profilo',
          event: 'show-profilo'
        },
        /*{
          id: 'sezione-gruppi',
          label: 'Gruppi',
          event: 'show-gruppi'
        },*/
        {
          id: 'sezione-lastminute',
          label: 'Last Minute',
          event: 'show-lastminute'
        }
      ];

      const allowed = Array.isArray(this.activeTab) ? this.activeTab : [this.activeTab];
      return allTabs.filter(tab => allowed.includes(tab.id));
    },
    showPrenSection() {
      return this.activeTabId === 'sezione-prenotazioni';
    },
    showInterazioniSection() {
      return this.activeTabId === 'sezione-interazioni';
    },
    showMaterieSection() {
      return this.activeTabId === 'sezione-materie';
    },
    showProfileSection() {
      return this.activeTabId === 'sezione-profilo';
    },
    showGruppiSection() {
      return this.activeTabId === 'sezione-gruppi';
    },
    showLastMinuteSection() {
      return this.activeTabId === 'sezione-lastminute';
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit(tab.event);

      this.emitSectionChange({
        pren: tab.id === 'sezione-prenotazioni',
        interazioni: tab.id === 'sezione-interazioni',
        materie: tab.id === 'sezione-materie',
        profile: tab.id === 'sezione-profilo',
        gruppi: tab.id === 'sezione-gruppi',
        lastminute: tab.id === 'sezione-lastminute'
      });
    },
    emitSectionChange({ pren, interazioni, materie, profile, gruppi, lastminute }) {
      this.$emit('update:showPrenSection', pren);
      this.$emit('update:showInterazioniSection', interazioni);
      this.$emit('update:showMaterieSection', materie);
      this.$emit('update:showProfileSection', profile);
      this.$emit('update:showGruppiSection', gruppi);
      this.$emit('update:showLastMinuteSection', lastminute);
    }
  }
}
</script>

<template>
  <div>
    <button v-if="currentUser.role==='buddy' || currentUser.role === 'developer'" class="btn mb-3 btn-success btn-sm" @click="$emit('change-section')">
      ← Torna al menu principale
    </button>
    <NavigationTabs
      v-model="activeTabId"
      :tabs="navigationTabs"
      @tab-click="handleTabClick"
    />

    <hr>

    <ListaPrenotazioni v-if="showPrenSection" :currentUser="currentUser" :user-type="'studente'"/>
    <ListaInterazioni v-if="showInterazioniSection" :current-user="currentUser"/>
    <GestioneMaterie v-if="showMaterieSection" :current-user="currentUser"/>
    <UserProfile
        v-if="showProfileSection"
        :userId="currentUser.id"
        :is-own-profile="true"
        :student="true"
    />
    <GestioneGruppi
        v-if="showGruppiSection"
        :current-user="currentUser"
    />
    <LastMinuteLessons v-if="showLastMinuteSection" :currentUserId="currentUser.id" />
  </div>
</template>
